/**
 * Ported from `packages/ja-core/src/hash.ts` in `git@git.fugl.dev:sks/yominoki.git` @ `515ce239`.
 * Bindery is canonical for this module from 2026-09-06; reconcile yominoki-side drift toward this
 * copy.
 */

// Stable cache keys for gloss_cache / tts_cache / usage_events text_hash.
// sha256 over canonical UTF-8; returns lowercase hex so it round-trips
// cleanly through Cockroach BYTEA via decode(..., 'hex').
//
// Uses WebCrypto (SubtleCrypto) — available in Node 20+, Bun, and workerd.

const encoder = new TextEncoder();

export async function sha256Hex(...parts: string[]): Promise<string> {
  const joined = parts.join("\u0000");
  const buf = await crypto.subtle.digest("SHA-256", encoder.encode(joined));
  const bytes = new Uint8Array(buf);
  let hex = "";
  for (const b of bytes) hex += b.toString(16).padStart(2, "0");
  return hex;
}

export function sentenceKey(sentence: string): Promise<string> {
  return sha256Hex("sentence", sentence);
}

export function tokenKey(surface: string, sentence: string): Promise<string> {
  return sha256Hex("token", surface, sentence);
}

export function ttsKey(text: string, voice: string): Promise<string> {
  return sha256Hex("tts", voice, text);
}
